import { Identifiers } from '@/types/identifiers';
import Konva from 'konva';
import { dataURLtoBlob } from './useDataUrlToBlob';
import { getFilterValues, setFilterValues } from './useKonvaFilterValues';
export function setFinalImageScale(quality, scale, tempLayer, stage) {
    const downloadImage = tempLayer.find(`#${Identifiers.IMAGE_ID}`)[0];
    const filters = downloadImage.filters();
    const filterValues = getFilterValues(downloadImage, filters);
    const finalChildren = tempLayer.getChildren();
    if (scale !== 1) {
        stage.setAttrs({
            width: (downloadImage.x() * 2 + downloadImage.width()) / scale,
            height: (downloadImage.y() * 2 + downloadImage.height()) / scale,
        });
        if (finalChildren.length) {
            finalChildren.forEach(child => {
                if (child instanceof Konva.Transformer) {
                    child.detach();
                }
                else {
                    if (child instanceof Konva.Image) {
                        child.clearCache();
                        child.setAttrs({
                            x: child.x() / scale,
                            y: child.y() / scale,
                            width: child.width() / scale,
                            height: child.height() / scale,
                        });
                        child.cache();
                        child.filters(filters);
                        setFilterValues(child, filterValues);
                    }
                    else if (child instanceof Konva.Label) {
                        child.getText().setAttrs({
                            width: child.getText().width() / scale,
                            height: child.getText().height() / scale,
                            fontSize: child.getText().fontSize() / scale,
                        });
                        child.setAttrs({
                            x: child.x() / scale,
                            y: child.y() / scale,
                            width: child.width() / scale,
                            height: child.height() / scale,
                        });
                        child.draw();
                    }
                    else if (child instanceof Konva.Line) {
                        const points = child.points().map(p => p / scale);
                        child.setAttrs({
                            strokeWidth: child.strokeWidth() / scale,
                            points: points,
                        });
                        child.draw();
                    }
                    else if (child instanceof Konva.Star) {
                        child.setAttrs({
                            x: child.x() / scale,
                            y: child.y() / scale,
                            innerRadius: child.innerRadius() / scale,
                            outerRadius: child.outerRadius() / scale,
                        });
                        child.draw();
                    }
                    else if (child instanceof Konva.Circle ||
                        child instanceof Konva.RegularPolygon) {
                        child.setAttrs({
                            x: child.x() / scale,
                            y: child.y() / scale,
                            radius: child.radius() / scale,
                        });
                        child.draw();
                    }
                    else {
                        child.setAttrs({
                            x: child.x() / scale,
                            y: child.y() / scale,
                            width: child.width() / scale,
                            height: child.height() / scale,
                        });
                    }
                }
            });
        }
        tempLayer.draw();
        stage.batchDraw();
    }
    const downloadImageData = stage.toDataURL({
        mimeType: 'image/jpeg',
        quality,
        x: downloadImage.x(),
        y: downloadImage.y(),
        width: downloadImage.width(),
        height: downloadImage.height(),
    });
    const blob = dataURLtoBlob(downloadImageData);
    return blob;
}
